<template>
  <EditDialog
    v-if="showModal"
    v-model:visible="showModal"
    :title="
      method === 'add'
        ? $t('components.SpaceForm.index.09e6dacdb1b67bd82aa08d61c9b08d89')
        : $t('components.SpaceForm.index.5bd8f25d7d72404657d7048c67f3c910')
    "
    :width="500"
    :mask-closable="false"
    :loading="loading"
    :padding="30"
    :sure-btn-text="$t('common.670d03777d5b44d8f57ccd3293b9bdd3')"
    @cancel="showModal = false"
    @submit="handleSubmit"
  >
    <div>
      <u-input v-model="spaceName" :maxlength="50" show-word-limit />
    </div>
  </EditDialog>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { defineComponent, ref, nextTick } from 'vue';
import { message } from '@koi-design/uxd-ui';
import {
  createHomelandApi,
  modifyCommonHomelandApi,
  getHomelandListApi
} from '@/api/homeland';

export default defineComponent({
  components: {},
  props: {
    type: {
      type: String,
      default: 'add'
    },
    name: {
      type: String,
      default: ''
    }
  },
  emits: ['change'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const store = useStore();
    const router = useRouter();
    const showModal = ref(false);
    const loading = ref(false);
    const method = ref(props.type);
    const spaceName = ref(props.name);
    const homelandId = ref(store.getters.homelandInfo.homeland);
    const homelandList = ref([]);
    const getHomelandList = async () => {
      const res = await getHomelandListApi();
      homelandList.value = res || [];
    };
    const handleSubmit = async () => {
      if (!spaceName.value) {
        message.error(
          t('components.SpaceForm.index.94f1d05edcf339675a3a39229c870ef0')
        );
        return;
      }
      loading.value = true;
      const API =
        method.value === 'add' ? createHomelandApi : modifyCommonHomelandApi;
      const params = {
        homeland_name: spaceName.value
      };
      if (method.value === 'edit') {
        params.id = homelandId.value;
      }
      try {
        const res = await API(params);
        if (res) {
          message.success(
            method.value === 'add'
              ? t('components.SpaceForm.index.1a739543662d6d2cc9fd4760a5236630')
              : t('components.SpaceForm.index.37820a5f9f3db01aff78f9b6ebace996')
          );
          if (method.value === 'add' && homelandList.value.length === 0) {
            store.commit('updateHomelandId', {
              ...store.getters.homelandInfo,
              ...res
            });
            store.commit('setUserInfo', {
              ...store.getters.botUserInfo,
              homeLandId: res.homeland
            });
            await nextTick();
            router.push('/workspace');
          }
          showModal.value = false;
          spaceName.value = '';
          emit('change', res);
        }
      } catch (err) {
        message.error(err);
      }
      loading.value = false;
    };
    const show = async () => {
      spaceName.value = props.name;
      showModal.value = true;
      getHomelandList();
    };
    return {
      show,
      loading,
      showModal,
      handleSubmit,
      method,
      spaceName
    };
  }
});
</script>

<style lang="less" scoped>
.dialog-body {
  --form-item-margin-bottom: 12px;
}
.item {
  height: 72px;
  background: var(--card-background-color);
  border-radius: 8px 8px 8px 8px;
  display: flex;
  align-items: center;
  margin-bottom: 13px;
  cursor: pointer;
  position: relative;
  border: 1px solid transparent;

  &.active {
    border: 1px solid var(--theme-color);
  }
  .icon-wrap {
    width: 36px;
    height: 36px;
    background-color: var(--icon-orange-color);
    border-radius: 50%;
    &.space {
      background-color: var(--icon-yellow-color);
    }
    margin: 0 8px 0 12px;
  }
  .publish-status {
    margin-left: 4px;
    font-size: 12px;
    line-height: 17px;
    vertical-align: middle;
    padding: 2px 8px;
    border-radius: 4px 4px 4px 4px;
    font-weight: 400;
    flex-shrink: 0;
    &.publish {
      color: var(--theme-color);
      background: var(--secondary-background-color);
    }

    &.public {
      color: var(--theme-orange-color);
      background: var(--theme-orange-background-color);
    }

    &.draf {
      color: var(--font-color);
      background: var(--label-background);
    }
  }
  .label {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translate(0, -50%);
    background: var(--icon-orange-color);
    height: 20px;
    line-height: 20px;
    padding: 0 8px;
    font-size: 12px;
    color: var(--white);
    border-radius: 6px;
    &-public {
      background: var(--icon-yellow-color);
    }
  }
}
.flow-name-wrap {
  display: flex;
  align-items: center;
}
.flow-name {
  display: inline-block;
  max-width: 400px;
}
</style>
